import React from 'react';
import Markdown, { MarkdownToJSX } from 'markdown-to-jsx';
import styles from './customMarkdown.module.scss';
import clsx from 'clsx';

interface CustomMarkdownProps {
    content: string;
    overrides?: MarkdownToJSX.Overrides;
    className?: string;
}

const CustomMarkdown: React.FC<CustomMarkdownProps> = ({ content, overrides, className }) => {
    const defaultOverrides: MarkdownToJSX.Overrides = {
        p: {
            component: ({ children }: { children: React.ReactNode }) => (
                <p className={styles.p}>{children}</p>
            ),
        },
        ul: {
            component: ({ children }: { children: React.ReactNode }) => (
                <ul className={styles.ul}>{children}</ul>
            ),
        },
        ol: {
            component: ({ children }: { children: React.ReactNode }) => (
                <ol className={styles.ol}>{children}</ol>
            ),
        },
        li: {
            component: ({ children }: { children: React.ReactNode }) => (
                <li className={styles.li}>{children}</li>
            ),
        },
        table: {
            component: ({ children }: { children: React.ReactNode }) => (
                <div className={styles['table-container']}>
                    <table className={styles.table}>{children}</table>
                </div>
            ),
        },
        th: {
            component: ({ children }: { children: React.ReactNode }) => (
                <th className={styles.th}>{children}</th>
            ),
        },
        td: {
            component: ({ children }: { children: React.ReactNode }) => (
                <td className={styles.td}>{children}</td>
            ),
        },
        a: {
            component: ({ children, ...props }: { children: React.ReactNode } & any) => (
                <a {...props} className={styles.a} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            ),
        },
        code: {
            component: ({ children, className }: { children: React.ReactNode; className?: string }) => {
                return <code className={clsx(styles.code, className)}>{children}</code>;
            },
        },
        pre: {
            component: ({ children }: { children: React.ReactNode }) => (
                <pre className={styles.pre}>{children}</pre>
            ),
        },
        ...overrides,
    };

    return (
        <div className={clsx(styles['custom-markdown'], className)}>
            <Markdown
                options={{
                    overrides: defaultOverrides,
                }}
            >
                {content}
            </Markdown>
        </div>
    );
};

export default CustomMarkdown;
